
import { alpha, styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';

const Container = styled('div')(({ theme, ...props }) => ({
  width: props.fullWidth?'100%':(props.width?props.width:'auto'),
}));


const InputBox = styled(InputBase)(({ theme, ...props }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    border: '1px solid',
    borderRadius: 4,
    // borderColor: props.error?"red":"#ced4da",
    boxShadow: props.error?'rgba(255, 0, 0, 0.5) 0px 0px 2px 3px, rgba(255, 0 ,0, 0.3) 0px 0px 1px 2px':'',
    borderColor: "#ced4da",
    position: 'relative',
    backgroundColor: props.backgroundcolor?props.backgroundcolor:(theme.palette.mode === 'light' ? '#fcfcfb' : '#2b2b2b'),
    textAlign: props.textalign?props.textalign:"left",
    width: '100%',
    padding: '10px 12px',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),

    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}));

const Error = styled('div')({
  color: 'red',
  fontSize: 15,
});

const BootstrapInput = (props) => {
  const inputProps = {...props};
  inputProps.error = !!props.error; // because InputBox error accept boolean
  return (
    <Container {...props} >
      <InputBox 
        {...inputProps} 
        endAdornment={props.endAdornment?props.endAdornment:null}
      />
      {props.error && <Error>{props.error}</Error>}
    </Container>
  )
}
export default BootstrapInput;
